import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    
    const api = await getAxiosInstance();
    const getParams = (key) => {
    
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?${getParams("start_date")}${getParams(
          "end_date"
        )}${getParams("filter")}${getParams("sort_by")}is_active=${
          params?.is_active ? params["is_active"] : 0
        }&sort_order=${
          params?.sort_order || "desc"
        }&per_page=${params?.per_page || "10"}&${getParams("search")}page=${
          params?.page || 1
        }`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const FAQ = createApi({
  reducerPath: "faqApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["FAQ"],
  endpoints: (builder) => ({
    getListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/faq/list`,
      }),
      providesTags: ["FAQ"],
    }),
    updateTableFieldsData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/v1/admin/table-permission-create`,
      }),

      invalidatesTags: ["FAQ"],
    }),
    updateStatusById: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `v1/admin/faq/status`,
      }),

      // invalidatesTags: ["FAQ"],
    }),
    getBasicData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/v1/admin/faq/faq-category-list`,
      }),
      providesTags: ["FAQ"],
    }),
  }),
});

export const { useGetListDataQuery, useUpdateTableFieldsDataMutation, useUpdateStatusByIdMutation, useGetBasicDataQuery } = FAQ;
